// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "core-js/stable"
import "regenerator-runtime/runtime"
import "stylesheets/application.scss"
import "jquery/dist/jquery.min"
import "../../../vendor/javascripts/jquery-ui.min"
import "bootstrap/dist/js/bootstrap.bundle.min"
import "@fortawesome/fontawesome-free/js/all"
import "animsition/dist/js/animsition.min"
import "jquery.appear/jquery.appear"
import "jquery-countto/jquery.countTo"
import "../../../vendor/javascripts/jquery.downCount.min"
import "easy-pie-chart/dist/easypiechart.min"
import "@fancyapps/fancybox/dist/jquery.fancybox.min"
import "../../../vendor/javascripts/jquery.fitvids.min"
import "isotope-layout/dist/isotope.pkgd.min"
import "mediaelement/build/mediaelementplayer.min.css"
import "mediaelement/build/mediaelement-and-player.min"
import "owl.carousel/dist/owl.carousel.min"
import "owl.carousel/dist/assets/owl.carousel.min.css"
import "owl.carousel/dist/assets/owl.theme.default.min.css"
import "pace-js/pace.min"
import "jquery-parallax/scripts/jquery.parallax-1.1.3"
import "perfect-scrollbar/dist/js/perfect-scrollbar.jquery.min"
import "sticky-sidebar/dist/jquery.sticky-sidebar.min"
import "../../../vendor/javascripts/tweetie.min"
import "zurb-twentytwenty/js/jquery.twentytwenty"
import "../../../vendor/javascripts/typed.min"
import "jquery-validation/dist/jquery.validate.min"
import "./scripts"

Rails.start()
ActiveStorage.start()

const images = require.context("../images", true)
const imagePath = (name) => images(name, true)
